import { useAtom } from '@reatom/npm-react'
import { memo, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { FlashTextContentDistinct } from '@root/features/flash/flash-text-content-distinct'
import { NumericFormat } from '@root/shared/core/format'
import { CrosshairIcon } from '@root/shared/ui-kit'

import { PairStatsPanelItem } from './pair-stats-panel-row-item'

import type { PairModel } from '@root/entities/pair'

type Props = {
  pair: PairModel
}

export const PairStatsPanelSnipers: React.FC<Props> = memo(({ pair }) => {
  const { t } = useTranslation()
  const [snipers] = useAtom(pair.snipers)

  const percentage = snipers.holding
  const formatted = useMemo(
    () => NumericFormat.formatPreset(percentage, 'percents'),
    [percentage],
  )

  return (
    <PairStatsPanelItem
      title={t('trading.audit.snipers')}
      intent="Safe"
      icon={CrosshairIcon}
      tooltip={t('trading.audit.snipers.holding-tooltip', {
        percentage: formatted,
      })}
      value={<FlashTextContentDistinct>{formatted}%</FlashTextContentDistinct>}
    />
  )
})
